import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import { BUTTON_TYPE } from 'redesign/components/templates/task-details-action-buttons/constant'
import type { ShowTeamplanButton } from '../../types'

export const getShowTeamplanButton = ({ t, handleButtonAction }: ShowTeamplanButton): Action => ({
  onClick: () => handleButtonAction(BUTTON_TYPE.displayAbsencePlannerDrawer),
  label: t('absenceRequest.buttons.showAbsencePlan'),
  testId: 'absence-request_action-show-absence-plan',
  variant: 'text',
  color: 'inherit',
})
